import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import VueLazyload from 'vue-lazyload'
import router from './router'
import store from './store'
import App from './App.vue'
import '@core/css/custom.css'
import './global-components'

import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, numeric, min_value } from 'vee-validate/dist/rules'


import '@/libs/portal-vue'
import '@/libs/toastification'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'dist/error.png',
  loading: 'dist/loading.gif',
  attempt: 1
})

Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueCompositionAPI)

Vue.component('pagination', require('laravel-vue-pagination'))

extend('required', required)
extend('numeric', numeric)
extend('min_value', min_value)

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

require('@core/scss/core.scss')
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
